<template>
  <a :href="sanitizeUrl(report.url)" target="_blank" rel="noopener" class="no-underline">
    <div class="d-flex align-items-center">
      <span class="hover-underline">{{ report.label }}</span>
      <span class="icon icon-datei_excel ml-2" aria-hidden="true"></span>
    </div>
  </a>
</template>

<script lang="ts">
import { Report } from '@/services/reportService';
import { defineComponent, PropType } from 'vue'
import { urlService } from '@/services/urlService';

export default defineComponent({
  name: 'LinkReport',
  props: {
    report: {
      type: Object as PropType<Report>,
      required: true
    }
  },
  methods: {
    sanitizeUrl(url: string) {
      return urlService.sanitizeThisUrl(url)
    }
  }
});
</script>
